import React from "react";
import { Link } from "react-router-dom";

const DevelopmentCourseRight = ({ courseDetails }) => {
  return (
    <div
      className=" w-full  bg-[#fff] rounded-[10px]"
      style={{ boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }}
    >
      <div>
        <iframe
          style={{ width: "100%", height: "300px" }}
          src="https://www.youtube.com/embed/ha4IyFDCdc?si=-sCoB6Ya29v07oAn"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      </div>
      <div className=" px-7 py-10">
        <h2 className="text-center text-linear-gradient font-extrabold font-fira mb-5 text-3xl">
          {courseDetails.price.price} BDT
        </h2>

        <ul>
          <li className="border-y-[2px] py-4 flex justify-between border-[#efefff]">
            <span>
              <i className="fas fa-user text-linear-gradient text-base"></i>{" "}
              <strong className="text-base font-medium ml-1 font-fira text-[#212832]">
                Instructor
              </strong>
            </span>
            <h6 className="text-base text-[#52565b] font-normal">
              {" "}
              {courseDetails.courseInfo.instructor}
            </h6>
          </li>
          <li className="border-b-[2px] py-4 flex justify-between border-[#efefff]">
            <span>
              <i className="fa-solid fa-clock text-linear-gradient text-base"></i>
              <strong className="text-base font-medium ml-1 font-fira text-[#212832]">
                Duration
              </strong>
            </span>
            <h6 className="text-base text-[#52565b] font-normal">
              {" "}
              {courseDetails.courseInfo.duration}
            </h6>
          </li>
          <li className="border-b-[2px] py-4 flex justify-between border-[#efefff]">
            <span>
              <i className="fas fa-video text-linear-gradient text-base"></i>
              <strong className="text-base font-medium ml-1 font-fira text-[#212832]">
                Classes
              </strong>
            </span>
            <h6 className="text-base text-[#52565b] font-normal">
              {" "}
              {courseDetails.courseInfo.classes} + Class
            </h6>
          </li>
          <li className="border-b-[2px] py-4 flex justify-between border-[#efefff]">
            <span>
              <i className="fas fa-book text-linear-gradient text-base"></i>
              <strong className="text-base font-medium ml-1 font-fira text-[#212832]">
                Language
              </strong>
            </span>
            <h6 className="text-base text-[#52565b] font-normal">
              {" "}
              {courseDetails.courseInfo.language}
            </h6>
          </li>
          <li className="border-b-[2px] py-4 flex justify-between border-[#efefff]">
            <span>
              <i className="fas fa-book text-linear-gradient text-base"></i>
              <strong className="text-base font-medium ml-1 font-fira text-[#212832]">
                Certificate
              </strong>
            </span>
            <h6 className="text-base text-[#52565b] font-normal">
              {" "}
              Yes ( Free )
            </h6>
          </li>
        </ul>
        {/* <div className="my-10">
          <a href="tel:01540343775">
            <button className="custom_button flex justify-center w-full items-center mx-auto ">
              {" "}
              <i className="fa-solid fa-phone mr-2"></i>CALL NOW 01960602760
            </button>
          </a>
        </div> */}
        <div className="my-10">
          <Link to={`/checkout/${courseDetails.slug}`}>
            <button
              style={{ boxShadow: "none" }}
              className="custom_button flex justify-center w-full items-center mx-auto "
            >
              কোর্সটি কিনুন
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DevelopmentCourseRight;
